module.exports = __webpack_public_path__ + "img/9.1ee47b9c.png";